import { useState } from 'react';
import { Button } from './ui/button';
import { Copy, Check } from 'lucide-react';
import { toast } from 'sonner';

interface CopyButtonProps {
  text: string;
  size?: 'sm' | 'default' | 'lg';
  variant?: 'default' | 'outline' | 'ghost';
  className?: string;
}

export function CopyButton({ text, size = 'sm', variant = 'outline', className = '' }: CopyButtonProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      toast.success(`Copied: ${text}`);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      toast.error('Failed to copy to clipboard');
    }
  };

  return (
    <Button
      size={size}
      variant={variant}
      onClick={handleCopy}
      className={`${className} ${copied ? 'bg-green-50 border-green-200' : ''}`}
    >
      {copied ? (
        <>
          <Check className="h-4 w-4 text-green-600" />
          <span className="ml-1 text-green-600">Copied</span>
        </>
      ) : (
        <>
          <Copy className="h-4 w-4" />
          <span className="ml-1">Copy</span>
        </>
      )}
    </Button>
  );
}